module.exports = __webpack_public_path__ + "img/pack_300.bc5bbe10.png";